import { SignUpForm } from "../../../platform/views/Auth/SignUp";

import { sanitizeSlug } from "../GeneratedTemplate/utils/sanitizeSlug";

import clsx from "clsx";

import { LandingCustomers } from "../LandingTemplate/components/LandingCustomers";
import { LandingSourceCarousel } from "../LandingTemplate/components/LandingSourceCarousel";

import Clearco from "../assets/logos/Clearco.svg";
import Openly from "../assets/logos/Openly.svg";
import Farmers from "../assets/logos/Farmers.svg";
import StandardChartered from "../assets/logos/StandardChartered.svg";
import Anz from "../assets/logos/Anz.svg";

import Featured1 from "../HomePage/assets/icons/Featured1.svg";
import Featured2 from "../HomePage/assets/icons/Featured2.svg";
import Featured3 from "../HomePage/assets/icons/Featured3.svg";
import ExternalDataSolutions from "../HomePage/assets/External_Data_Solutions.svg";

export const ThirdPartyOrExternalData = ({ dataSources, keyword }) => {
  const landingCustomersData = {
    fields: {
      subheadline: `Join the customers already unlocking the power of ${keyword} data with Demyst:`,
      logos: [
        {
          image: Farmers.src,
          image_alt: "Farmers Insurance",
        },
        {
          image: Anz.src,
          image_alt: "ANZ",
        },
        {
          image: StandardChartered.src,
          image_alt: "Standard Chartered",
        },
        {
          image: Openly.src,
          image_alt: "Openly",
        },
        {
          image: Clearco.src,
          image_alt: "Clearco (formerly Clearbank)",
        },
      ],
    },
  };
  return (
    <>
      <section className={clsx("LandingHero-background", "Campaign", "Campaign-WithCarousel")}>
        <LandingSourceCarousel backgroundColor="teal" data={dataSources} />
        <div
          className={clsx(
            "Campaign",
            "Campaign-WithCarousel",
            "LandingHero",
            "LandingHero-align-left",
            "LandingHero-type-platform-sign-up",
          )}
          id="hero"
        >
          <section className="section-layout">
            <h1 className="LandingHero-title">
              Enrich Your Data With {sanitizeSlug(keyword, "titlecase")} Data APIs
            </h1>
            <p className="LandingHero-subtitle">
              Demyst simplifies and accelerates access to{" "}
              {sanitizeSlug(keyword, "sentenceLowerCase")} data by allowing businesses to create{" "}
              {sanitizeSlug(keyword, "sentenceLowerCase")} data APIs to optimize their operations
              and elevate their intelligence.
            </p>
          </section>
          <section className="section-layout">
            <SignUpForm
              className="LandingHero-form"
              showLogInLink={false}
              titleOverride="Sign Up to the Demyst Platform and Access Free Sample Data"
              sentTitleOverride=""
              sentMessageOverride=""
            />
          </section>
        </div>
      </section>
      <div
        className={clsx(
          "LandingMainContent",
          "LandingMainContent-background-gray-2",
          "LandingMainContent-align-left",
          "LandingMainContent-text_image",
          "Campaign",
        )}
        id="api-deployment"
      >
        <section className="section-layout">
          <div
            className={clsx(
              "LandingTextImageContent-col",
              "LandingTextImageContent-col-text",
              `LandingTextImageContent-col-text-position-left`,
            )}
          >
            <h2>The all-in-one platform for external data</h2>
            <ul className="LandingTextImageContent-customUl2">
              <li>
                <img src={Featured1.src} alt="" width="48" height="48" loading="lazy" />
                <div>
                  <h3>Rapidly deploy {keyword} data</h3>
                  <p>
                    Deploy Data APIs or shared full files of {keyword} data up to 10x faster. Demyst
                    integrates into your production applications, CRM, data lake, warehouse and
                    more.
                  </p>
                </div>
              </li>
              <li>
                <img src={Featured2.src} alt="" width="48" height="48" loading="lazy" />
                <div>
                  <h3>Ease compliance burden with a single partnership</h3>
                  <p>
                    Demyst delivers an industry leading data provider certification process for safe
                    and compliant data access. We perform regular legal, privacy and security due
                    diligence so that you don't need to for all the data you deploy.
                  </p>
                </div>
              </li>
              <li>
                <img src={Featured3.src} alt="" width="48" height="48" loading="lazy" />
                <div>
                  <h3>Manage all your {keyword} data in one place</h3>
                  <p>
                    With Demyst you can use a single global interface for all your {keyword} data
                    discovery, solution builds and deployments.
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div className="LandingTextImageContent-col">
            <img src={ExternalDataSolutions.src} alt="" loading="lazy" width="588" height="506" />
          </div>
        </section>
      </div>
      <div
        className={clsx(
          "LandingMainContent",
          "LandingMainContent-background-blue",
          "LandingMainContent-align-center",
          "LandingMainContent-customers",
          "Campaign",
        )}
        id="customers"
      >
        <LandingCustomers data={landingCustomersData} />
      </div>
    </>
  );
};
